import script from "./TermTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./TermTemplate.vue?vue&type=script&setup=true&lang=js"

import "./TermTemplate.vue?vue&type=style&index=0&id=57eee296&lang=scss"

const __exports__ = script;

export default __exports__